import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import { RiDeleteBin6Line } from 'react-icons/ri';
import { useSelector } from "react-redux";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {FiEdit} from 'react-icons/fi';

export default function MyJobPost(props) {

  // Local State 
  const [flag, setFlag] = useState('');

  // Redux State
  const token = useSelector(state => state.auth.token);
  const userData = useSelector(state => state.auth.data);

  // delete job 
  const deleteJobPost = async (e, jobID) => {
    e.preventDefault();
    
    let isAssigned = props?.post?.assign_post !== null && Object.keys(props?.post?.assign_post).length > 0 ? true : false;

    if(isAssigned){
      toast.warn("This Job Can't be Deleted, because it is assigned.");
    } else {
      
      let txt = "You are about to delete a job, if deleted it can't be restored. Do you want to Delete this Job?";
      if(window.confirm(txt) == true){        
        // deleting posts
        await fetch(`${process.env.REACT_APP_BASE_URL}/api/posts/${jobID}`, {
          method: "DELETE",
          headers: {
            "Authorization": `Bearer ${token}`
          }
        })
          .then(r => r.json())
          .then(async (response) => {
            if (response.success) {
              if (response.success) {
                toast.success(response.message, {hideProgressBar: true});
                setTimeout(() => {
                  props.setAction("delete action success");
                }, 1000);
              } else {
                toast.warn(response.message);
                props.setAction("delete action success");
              }  
            } else {
              toast.warn(response.message);
            }
          })
      }
    }

  }


  return (
    <>
      <div className="bds-box">
        <div className="bds-cardtitle">
          <h4 className="">{props?.post?.title}</h4>
          <h6 className="text-sky-blue mb-3">
            {props?.post?.service?.service_name}
          </h6>
          <p>{props?.post?.description}</p>
        </div>
          <p className="fw-bold mt-2">
            {props?.post?.status == 2 && <span>Deadline:</span> }
            {props?.post?.status == 3 && <span>Task Completed Date:</span> }

            <small className="text-sky-blue d-block">
              { props?.post?.status == 2 && moment(props?.post?.task_completion_date).format("MMMM Do YYYY") }
              { props?.post?.status == 3 && moment(props?.post?.updated_at).format("MMMM Do YYYY") }
            </small>
          </p>
        {/* <div className="mt-4">
          <h6 className="mb-0 lh-sm fw-normal">Status:</h6>
          <p>
            <small className="text-uppercase fw-bold text-sky-blue">
              {props?.post?.status == 1 && "Pending"}
            </small>
          </p>
        </div> */}
        {/* <Link to={`/jobs/${props?.post?.assign_post?.post_id}`} className="bds-btn-solid mt-3 me-3">View Detail
        </Link> */}
        <Link to={`/jobs/${props?.post?.id}`} className="bds-btn-solid mt-3 me-3">View Detail
        </Link>
        {
          userData?.role === 3 && props.post?.status !== 3 && 
          <Link
                className="btn rounded-lg"
                to={`/edit-jobs/${props?.post?.id}`}
              >
                <FiEdit />                
              </Link>
        }
        {
          userData?.role === 3 && props?.post?.status == 1 &&
          (
            <>
              {/* <Link to={`/bids?post_id=${props?.post?.id}&&bid_id=`}>
                <a className="bds-btn-solid mt-3 me-3">View Proposals</a>
              </Link> */}              
              <button
                className="btn btn-danger rounded-lg"
                type="button"
                onClick={e => deleteJobPost(e, props?.post?.id)}
              >
                <RiDeleteBin6Line />
              </button>
            </>
          )
        }        
      </div>
      <ToastContainer />
    </>
  );
}
